import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

export const yellowPageSchema = new schema.Entity(
    'yellow_pages',
    {},
    {
        idAttribute: 'id',
    }
)

export const yellowPage_createNewYellowPage_Api = {
    name: 'yellow_createNewYellowPage_Api',
    backend: `Route::post('yellow-pages/add', 'YellowPageController@add');`,
    root: API_ROOT_URL,
    path: '/yellow-pages/add',
    method: 'POST',
    schema: yellowPageSchema,
    transform: createTransform(yellowPageSchema, 'data'),
}

export const yellowPage_getYellowPages_Api = {
    name: 'yellow_getYellowPages_Api',
    backend: `Route::get('yellow-pages/{type}/{id}/gets', 'YellowPageController@getYellowPages');`,
    root: API_ROOT_URL,
    path: '/yellow-pages/:type/:id/gets',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: yellowPageSchema,
    transform: createListTransform(yellowPageSchema),
}

export const yellowPage_deleteYellowPage_Api = {
    name: 'yellow_deleteYellowPage_Api',
    backend: `Route::post('yellow-pages/yellow-page/{id}/delete', 'YellowPageController@delete');`,
    root: API_ROOT_URL,
    path: '/yellow-pages/yellow-page/:id/delete',
    method: 'POST',
    schema: yellowPageSchema,
    transform: createTransform(yellowPageSchema, 'data'),
}

export const yellowPage_editYellowPage_Api = {
    name: 'yellow_editYellowPage_Api',
    backend: `Route::post('yellow-pages/yellow-page/{id}/edit', 'YellowPageController@edit');`,
    root: API_ROOT_URL,
    path: '/yellow-pages/yellow-page/:id/edit',
    method: 'POST',
    schema: yellowPageSchema,
    transform: createTransform(yellowPageSchema, 'data'),
}

export const yellowPage_getById_Api = {
    name: 'course_getCourseById_Api',
    backend: `Route::get('yellow-pages/yellow-page/{id}/get', 'YellowPageController@getById');`,
    root: API_ROOT_URL,
    path: '/yellow-pages/yellow-page/:id/get',
    method: 'GET',
    schema: yellowPageSchema,
    transform: createTransform(yellowPageSchema, 'data'),
}

export const yellowPage_fetchYellowPages = {
    name: 'yellow_fetchYellowPages',
    backend: `Route::get('yellow-pages/search', 'YellowPageController@fetchYellowPages');`,
    root: API_ROOT_URL,
    path: '/yellow-pages/search',
    method: 'GET',
    paramsFields: ['keyword', 'hashtags', 'country_id', 'province_id'],
    schema: yellowPageSchema,
    transform: createListTransform(yellowPageSchema),
}

export const yellowPage_getHighlighted_Api = {
    name: 'yellow_getHighlighted',
    backend: `Route::get('yellow-pages/get-yellow-pages-highlighted', 'YellowPageController@getYellowPagesHighlighted');`,
    root: API_ROOT_URL,
    path: '/yellow-pages/get-yellow-pages-highlighted',
    method: 'GET',
    paramsFields: [],
    schema: yellowPageSchema,
    transform: createListTransform(yellowPageSchema),
}